import React, { useState } from 'react'
import Breadcrumbs from '../../layout/breadcrumb'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "./list.css"
import Manpower from './manpower';
import Material from './material';
import Machinery from './machinery';
import DprHeader from '../../layout/dprHeader';
import { useLocation } from 'react-router-dom';

export default function ListOfResources() {
      const location = useLocation();
      const data = location.state || {};
    const [resourceTitle, setResourceTitle] = useState("Manpower");
    return (
        <div className='pb-5'>
            <Breadcrumbs title="Resources" menu="" link="Resources" />
            <DprHeader project={data}/>
            <div className='card pb-5 card-none mt-3'>
                <div className='row mt-3'>
                    <Tabs>
                        <div className='row' id='risk-register' style={{marginLeft:10,marginRight:10}}>
                            <div className='col-4'>
                                <TabList>
                                    <Tab onClick={() => { setResourceTitle("Manpower") }} >Manpower</Tab>
                                    <Tab onClick={() => { setResourceTitle("Machinery") }} >Machinery</Tab>
                                    {/* <Tab onClick={() => { setResourceTitle("Material") }} >Material</Tab> */}
                                </TabList>
                            </div>
                        <hr/>        
                        </div>
                        <div className='row' style={{ marginLeft: 20 }}>
                            <TabPanel>
                                <Manpower />
                            </TabPanel>
                            <TabPanel>
                                <Machinery />
                            </TabPanel>
                            {/* <TabPanel>
                                <Material />
                            </TabPanel> */}
                        </div>
                    </Tabs>
                </div>
            </div>
        </div>
    )
}
